import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "feature-toggle",
    { attrs: { toggle: _vm.createWorkpackageReadsFromDatabricks } },
    [
      _c(
        VRow,
        { attrs: { "no-gutters": "" } },
        [
          _c(VCol, { attrs: { cols: "12" } }, [
            _c(
              "div",
              { staticClass: "refresh-from-feed-wrapper" },
              [
                _c(VSwitch, {
                  staticClass: "font-weight-regular",
                  attrs: {
                    label: _vm.$t("workPackages.refreshFromFeed"),
                    "input-value": _vm.createWorkpackageRefreshFromFeed,
                    disabled: _vm.isDisabled || _vm.forceDisabled,
                    primary: "",
                    "hide-details": "",
                  },
                  on: { change: _vm.toggleRefreshFromFeed },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }